import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.element.value = this.element.checked;
    this.element.addEventListener('change', this.changed);
  }

  changed = () => {
    this.element.value = this.element.checked;
  }

  disconnect() {
    this.element.removeEventListener('change', this.changed);
  }
}


